import { Pipe, PipeTransform } from '@angular/core';

import { hasUserStation } from '../constants/constants';

@Pipe({ name: 'hasUserStation', standalone: true })
export class HasUserStationPipe implements PipeTransform {
  transform(
    userData,
    product,
    section: string,
    areAllProductsSelected
  ): boolean {
    return hasUserStation(userData, product, section, areAllProductsSelected);
  }
}
